const pascalCaseFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function generateHookExports(service, prefix) {
  const exports = {};
  Object.entries(service).forEach(([key, hookFn]) => {
    if (typeof hookFn === 'function') {
      const exportName = `${prefix}${pascalCaseFirst(key)}`;
      exports[exportName] = hookFn;
    }
  });
  return exports;
}
